module.exports = __webpack_public_path__ + "static/media/Swinub_gaussian2.0e12d32c.png";